<template>
    <div class="modal fade" id="campaignLocationDetailsModal" ref="campaignLocationDetailsModal" tabindex="-1" role="dialog" aria-labelledby="campaignLocationDetailsModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="campaignLocationDetailsModalLabel">{{ $t('campaign_location_details.title') }}</h5>
                        </div>
                        <div class="col-12 mt-3">
                            <span class="detail-data canvassing-color-black">{{ location.name }}</span>
                        </div>
                        <div class="col-12 mt-2">
                        </div>
                        <div class="col-12 mt-2">
                            <span class="detail-data canvassing-color-black">{{ $t('campaign_location_details.location_created_by') }} {{ location.created_by.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "CampaignLocationDetailsModal",
        props: ["location"],
        mixins: [HelperMixin],
        data() {
            return {
                
            }
        },
        created() {
            
        },
        computed: {
        
        },
        methods: {
            dismissDetails() {
                $('#campaignLocationDetailsModal').modal('hide');
            },
        },
    };
</script>
